<template>
  <BaseBlock title="Demandes en cours d'étude">
    <v-container>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Filtres de recherche
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row align="center">
              <v-col cols="2">
                <v-text-field
                  v-model="search.etablissement"
                  label="établissement"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="search.demandeur"
                  label="demandeur"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select
                  v-model="search.avisCROP"
                  :items="getAvisCROPSelectData()"
                  label="avis du CROP"
                  clearable
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <SearchDateWidget
              :searchOnDate="search.searchOnDate"
              v-on:update:searchOnDate="search.searchOnDate = $event"
              :dateMin="search.dateMin"
              v-on:update:dateMin="search.dateMin = $event"
              :dateMax="search.dateMax"
              v-on:update:dateMax="search.dateMax = $event"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        :headers="headers"
        :items="dossiersEnAttenteDAvis"
        v-if="dossiers"
      >
        <!-- template du header "voir" -->
        <template v-slot:[`header.dossier`]="{}">
          <v-icon>mdi-eye</v-icon>
        </template>
        <!-- template des cellules "voir" -->
        <template v-slot:[`item.dossier`]="{ item }">
          <LinkToPDFWidget :dossier="item" />
        </template>
        <!-- template des cellules "établissement" -->
        <template v-slot:[`item.officine.denomination`]="{ item }">
          <div class="text-body-2">{{ item.officine.denomination }}</div>
          <div class="text-caption grey--text font-italic">
            {{ item.officine.codePostal }}
            -
            {{ item.officine.ville }}
          </div>
        </template>
        <!-- template des cellules "demandeur" -->
        <template v-slot:[`item.demandeur`]="{ item }">
          <div class="text-body-2">{{ item.demandeur }}</div>
          <div class="text-caption grey--text font-italic">
            <a
              target="_blank"
              :href="
                `mailto:${item.contactMail}?subject=Pharmagrément - Suivi du dossier de demande d'agrément de: ${item.officine.denomination}`
              "
            >
              {{ item.contactMail }}
            </a>
          </div>
        </template>
        <!-- template des cellules "type" -->
        <template v-slot:[`item.premiereDemande`]="{ item }">
          <div class="text-body-2">
            {{ item.premiereDemande ? "Première demande" : "Renouvellement" }}
          </div>
        </template>
        <!-- template des cellules "date" -->
        <template v-slot:[`item.dateDepot`]="{ item }">
          <div class="text-body-2">{{ getDate(item.dateDepot) }}</div>
        </template>
        <!-- template des cellules "avisCROP" -->
        <template v-slot:[`item.avisCROP`]="{ item }">
          <div class="text-body-2">
            {{
              item.avisCROP ? getAvisLibelle(item.avisCROP.avis) : "Pas d'avis"
            }}
          </div>
        </template>
        <!-- template des cellules "actions" -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-center">
            <div v-if="item.avisCROP">
              <v-btn @click="openEditAvisModificationDialog(item)" x-small>
                modifier un avis
              </v-btn>
            </div>
            <div v-else>
              <v-btn @click="openEditAvisModificationDialog(item)" x-small>
                émettre un avis
              </v-btn>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-container>
    <!-- popup voir avis du CROP -->
    <ModalEditAvisCROP
      :avis="currentAvisCROP"
      :dossier="currentDossier"
      :display="modalEditAvisCROPDisplay"
      v-on:update:display="modalEditAvisCROPDisplay = $event"
      v-on:ModalAvisCROPAction="actionAvisCROP($event)"
      v-if="modalEditAvisCROPDisplay"
    />
  </BaseBlock>
</template>

<script>
import { mapState } from "vuex";
import common from "@/common";
import ApiAvisCROPRepository from "@/repositories/ApiAvisCROPRepository";
import BaseBlock from "@/components/base/BaseBlock";
import LinkToPDFWidget from "@/components/LinkToPDFWidget";
import SearchDateWidget from "@/components/SearchDateWidget";
import ModalEditAvisCROP from "@/components/ModalEditAvisCROP";

export default {
  name: "RecevabiliteDesDemandes",
  components: {
    BaseBlock,
    LinkToPDFWidget,
    ModalEditAvisCROP,
    SearchDateWidget
  },
  data() {
    return {
      refresh_dossier_timer: null,
      modalEditAvisCROPDisplay: false,
      currentAvisCROP: null,
      currentDossier: null,
      search: {
        etablissement: "",
        demandeur: "",
        avisCROP: null,
        searchOnDate: false,
        dateMin: null,
        dateMax: null
      },
      headers: [
        {
          align: "center",
          sortable: false,
          value: "dossier"
        },
        {
          text: "Etablissement",
          align: "start",
          sortable: true,
          value: "officine.denomination"
        },
        {
          text: "Demandeur",
          align: "start",
          sortable: true,
          value: "demandeur"
        },
        {
          text: "Type",
          align: "start",
          sortable: true,
          value: "premiereDemande"
        },
        {
          text: "Date de dépot de la demande",
          align: "start",
          sortable: true,
          value: "dateDepot"
        },
        {
          text: "Avis du CROP",
          align: "start",
          sortable: false,
          value: "avisCROP"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  computed: {
    ...mapState(["dossiers", "user"]),
    dossiersEnAttenteDAvis() {
      return this.dossiers
        .filter(d => {
          if ("" !== this.search.etablissement) {
            if (
              !d.officine ||
              !d.officine.denomination
                .toLowerCase()
                .includes(this.search.etablissement)
            )
              return false;
          }
          if ("" !== this.search.demandeur) {
            if (!d.contactPrenom || !d.contactNom) return false;
            if (
              !(d.contactPrenom + " " + d.contactNom)
                .toLowerCase()
                .includes(this.search.demandeur)
            )
              return false;
          }
          if (null !== this.search.avisCROP) {
            if (this.search.avisCROP === 2 && d.avisCROP) return false;
            if (
              this.search.avisCROP === false &&
              (!d.avisCROP || d.avisCROP.avis === true)
            )
              return false;
            if (
              this.search.avisCROP === true &&
              (!d.avisCROP || d.avisCROP.avis === false)
            )
              return false;
          }
          if (
            this.search.searchOnDate &&
            !common.matchDate(d, this.search.dateMin, this.search.dateMax)
          )
            return false;
          return common.isAttente(d);
        })
        .map(d => {
          d.demandeur = d.contactPrenom + " " + d.contactNom;
          return d;
        });
    }
  },
  async created() {
    if (null === this.dossiers) await this.loadDossiers();
    else this.loadDossiers();
    this.refresh_dossier_timer = setInterval(
      this.loadDossiers,
      common.REFRESH_TIMER
    );
  },
  beforeDestroy() {
    clearInterval(this.refresh_dossier_timer);
  },
  methods: {
    async loadDossiers() {
      this.$store.dispatch("loadDossiers");
    },
    getDate(timestamp) {
      return common.formatDate(timestamp);
    },
    getAvisLibelle(avis) {
      return common.getAvisLibelle(avis);
    },
    getAvisCROPSelectData() {
      return common.getAvisCROPSelectData();
    },
    async openEditAvisModificationDialog(dossier) {
      if (dossier.avisCROP) {
        if (
          !(
            this.currentAvisCROP &&
            this.currentAvisCROP.id === dossier.avisCROP.id
          )
        )
          this.currentAvisCROP = await ApiAvisCROPRepository.get(
            dossier.avisCROP.id
          );
      } else {
        this.currentAvisCROP = {
          avis: null,
          commentaire: "",
          critereMoralite: false,
          date: null,
          dpcValidee: false,
          etat: false,
          id: null
        };
      }
      this.currentDossier = dossier;
      this.modalEditAvisCROPDisplay = true;
    },
    async actionAvisCROP(dialogData) {
      let avis = null;
      dialogData.dossier = { id: this.currentDossier.id };
      if (null === dialogData.id) {
        //Création
        avis = await ApiAvisCROPRepository.new(dialogData);
      } else {
        //modification
        avis = await ApiAvisCROPRepository.update(dialogData.id, dialogData);
      }
      this.currentDossier.avisCROP = avis;
      this.$store.dispatch("updateDossier", this.currentDossier);
    }
  }
};
</script>
